import { render, staticRenderFns } from "./qualification.vue?vue&type=template&id=b3096146&scoped=true"
import script from "./qualification.vue?vue&type=script&lang=js"
export * from "./qualification.vue?vue&type=script&lang=js"
import style0 from "./qualification.vue?vue&type=style&index=0&id=b3096146&prod&lang=scss"
import style1 from "./qualification.vue?vue&type=style&index=1&id=b3096146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3096146",
  null
  
)

export default component.exports